import type { FaireProductEntity } from "../../entity_types/product";

export const p_gfe7vxfpuq: FaireProductEntity = {
  token: "p_gfe7vxfpuq",
  type: "product",
  name: "Après-Ski - 1000 Piece Puzzle",
  brandToken: "b_1oesixpi34",
  brandName: "Piecework",
  imageUrl:
    "https://cdn.faire.com/fastly/020648a10d83dae4e696e0c453d243d43e61fd47bc2b70060508f65f4527656d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b46bf8e1b246bc1e74ddba4288430726f43bb024e3b0fec99899db6e2454a8e3.jpeg",
    "https://cdn.faire.com/fastly/6e6d4a54b5342fbaffcce1beecc8e262bed2d3c8f407ca0a5ba7ebe0604a79d6.png",
    "https://cdn.faire.com/fastly/7afa6a6cd59405ecf775aba96ee14e9acb3312cb10d1fd1da3210eeeb860127d.png",
  ],
  priceDollars: 20,
  description:
    "Warm your hands by this winter moment: you’re back at the chalet for the storied tradition of decadent snacks and libations after a day on the slopes. Stick around. There may or may not be Jägermeister shots later.\n\n• Random ribbon-cut pieces\n• Completed puzzle is 19.25 x 26.6 inches\n• Box is 8 x 10 x 1.8 inches\n• Thick stock and high-quality art paper\n• Not suitable for children\n• Board is 100% recycled paper\n\nMother's Day gifts - Spring - Summer - Easter - Hostess Gift",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:26.445Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
